import { useState } from 'react';
/* document */
import { BlockMenuAdmin } from '../../Admin/Blocks/BlockMenuAdmin.js';
import { FinderAdmin } from './FinderAdmin.js';
import { Selector } from './Selector.js';
import { ButtonInsert } from '../Form/Buttons/ButtonInsert.js';
import { Logout } from '../../../Pages/Admin/Logout.js';

export const Navigation = (props) => {
    const { entity, clock } = props;
    const chooser = props.chooser ? props.chooser : [];
    const [show, setShow] = useState(0);
    const [showSub, setShowSub] = useState(0);
    const token = sessionStorage.getItem('token');
    if (token && !window.location.href.match(/admin\/login/)) {
        return (
            <div className="admin-nav">
                <div className="buttons">
                    <div className="slider" onClick={() => { show === 0 ? setShow(1) : setShow(0); setShowSub(0); }}>
                        <i className="fa fa-bars"></i>
                    </div>
                    <div className={`nav-1 ${show === 1 ? 'show' : 'hide'}`}>
                        <BlockMenuAdmin label="testroutes" showSub={showSub} setShowSub={setShowSub} />
                        <BlockMenuAdmin label="entities" showSub={showSub} setShowSub={setShowSub} />
                        <BlockMenuAdmin label="attributes" showSub={showSub} setShowSub={setShowSub} />
                        <BlockMenuAdmin label="describes" showSub={showSub} setShowSub={setShowSub} />
                    </div>
                    {clock}
                </div>
                <div className="buttons">
                    <ButtonInsert entity={entity} />
                    <FinderAdmin table={entity} />
                    <Selector entity={entity} chooser={chooser} />
                    <Logout />
                </div>
            </div >
        )
    } else {
        return (<></>)
    }

}